import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import { StatusBadge } from "../../../../../common/Badge";

const ModuleAccessTable = ({
  data,
  onEdit,
  currentPage,
  setCurrentPage
}) => {
  const headers = [
    "ID",
    "Access Type",
    "Allow Skip Approval",
    "Allow Departure Button",
    "Allow Onboard Button",
    "Process Manager",
    "Assigned Employee",
    "Actions"
  ];

  const accessors = [
    "id",
    "description",
    "allowSkipApproval",
    "allowDepartedButton",
    "allowArrivedButton",
    "isEmployeeTransactionProcessManager",
    "isEmployeeTransactionAssignedEmployee",
    "actions"
  ];

  const customCellRenderer = (row, accessor) => {
    const booleanFields = [
      "allowSkipApproval",
      "allowDepartedButton",
      "allowArrivedButton",
      "isEmployeeTransactionProcessManager",
      "isEmployeeTransactionAssignedEmployee"
    ];

    if (booleanFields.includes(accessor)) {
      return <StatusBadge status={row[accessor] ? "Yes" : "No"} />;
    }
    return null;
  };

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Employee Transaction Access List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customCellRenderer={customCellRenderer}
    />
  );
};

export default ModuleAccessTable;